import React from 'react';
import { useTranslation } from 'react-i18next';

// The line under a mobile field that turns typing the number into a yes to WhatsApp
// confirmations from this brand (the API records it as data.WhatsAppConsent). Only on screens
// where somebody DOES something with us — checkout, a seat, a ticket, a team invite — never on
// a lead form: a prospect gets no WhatsApp. Named after the brand when the screen knows it,
// because that is the name the messages will come from.
const WhatsAppNotice = ({ brandName }) => {
  const { t } = useTranslation();
  return (
    <p className="auth__hint mt-1 mb-0">
      {brandName ? t('whatsappNoticeBrand', { brand: brandName }) : t('whatsappNotice')}
    </p>
  );
};

export default WhatsAppNotice;
